import { useEffect } from 'react'
import { useMap } from 'react-map-gl/maplibre'

export const FlyToBounds = ({
  centerPoint,
  zoom = 12
}: {
  centerPoint: { lat: string; lon: string }
  zoom?: number
}) => {
  const { current: map } = useMap()
  useEffect(() => {
    if (!map) return

    map.flyTo({
      center: { lng: Number(centerPoint.lon), lat: Number(centerPoint.lat) },
      zoom,
      animate: true,
      duration: 1000
    })
  }, [centerPoint, map])

  return null
}

export const useFlyTo = (centerPoint: { lat: string; lon: string }) => {
  const { current: map } = useMap()
  useEffect(() => {
    if (!map) return

    map.flyTo({
      center: { lng: Number(centerPoint.lon), lat: Number(centerPoint.lat) },
      zoom: 11,
      animate: true,
      duration: 1000
    })
  })
}
